import api from './api';

const messageService = {
  // Récupérer toutes les conversations de l'utilisateur
  getConversations: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/messages/conversations?${queryString}` : '/messages/conversations';
    
    return await api.get(url);
  },

  // Récupérer les messages d'une conversation
  getConversationMessages: async (conversationId, params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/messages/conversations/${conversationId}?${queryString}` : `/messages/conversations/${conversationId}`;
    
    return await api.get(url);
  },

  // Envoyer un message
  sendMessage: async (messageData) => {
    return await api.post('/messages/send', messageData);
  },

  // Envoyer un message avec pièce jointe
  sendMessageWithAttachment: async (formData) => {
    return await api.post('/messages/send', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Marquer un message comme lu
  markAsRead: async (messageId) => {
    return await api.put(`/messages/${messageId}/read`);
  },

  // Marquer tous les messages d'une conversation comme lus
  markConversationAsRead: async (conversationId) => {
    return await api.put(`/messages/conversations/${conversationId}/read`);
  },

  // Supprimer un message
  deleteMessage: async (messageId) => {
    return await api.delete(`/messages/${messageId}`);
  },

  // Supprimer une conversation
  deleteConversation: async (conversationId) => {
    return await api.delete(`/messages/conversations/${conversationId}`);
  },

  // Rechercher dans les messages
  searchMessages: async (query, params = {}) => {
    const queryParams = new URLSearchParams({ q: query });
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    return await api.get(`/messages/search?${queryParams.toString()}`);
  },

  // Compter les messages non lus
  getUnreadCount: async () => {
    return await api.get('/messages/unread-count');
  },

  // Compter les messages non lus par conversation
  getUnreadCountByConversation: async () => {
    return await api.get('/messages/unread-count/conversations');
  },

  // Bloquer un utilisateur
  blockUser: async (userId) => {
    return await api.post('/messages/block', { userId });
  },

  // Débloquer un utilisateur
  unblockUser: async (userId) => {
    return await api.post('/messages/unblock', { userId });
  },

  // Récupérer la liste des utilisateurs bloqués
  getBlockedUsers: async () => {
    return await api.get('/messages/blocked-users');
  },

  // Créer une nouvelle conversation
  createConversation: async (participantId) => {
    return await api.post('/messages/conversations', { participantId });
  },

  // Récupérer les détails d'une conversation
  getConversationDetails: async (conversationId) => {
    return await api.get(`/messages/conversations/${conversationId}/details`);
  },

  // Archiver une conversation
  archiveConversation: async (conversationId) => {
    return await api.put(`/messages/conversations/${conversationId}/archive`);
  },

  // Désarchiver une conversation
  unarchiveConversation: async (conversationId) => {
    return await api.put(`/messages/conversations/${conversationId}/unarchive`);
  },

  // Récupérer les conversations archivées
  getArchivedConversations: async () => {
    return await api.get('/messages/conversations/archived');
  },

  // Signaler un message
  reportMessage: async (messageId, reason) => {
    return await api.post(`/messages/${messageId}/report`, { reason });
  },

  // Récupérer l'historique des messages avec un utilisateur
  getMessageHistory: async (userId, params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/messages/history/${userId}?${queryString}` : `/messages/history/${userId}`;
    
    return await api.get(url);
  }
};

export default messageService;